import { Fade } from './Fade';
import { HorizontalUnroll } from './HorizontalUnroll';
import { Unroll } from './Unroll';

export const Animation = {
  Unroll: Object.assign(Unroll, {
    Horizontal: HorizontalUnroll,
  }),
  Fade,
};
